module.exports = __webpack_public_path__ + "./favicons/android-icon-256x256.png";